import { render, staticRenderFns } from "./QueryContractItem_IV.vue?vue&type=template&id=6edcb72a"
import script from "./QueryContractItem_IV.vue?vue&type=script&lang=js"
export * from "./QueryContractItem_IV.vue?vue&type=script&lang=js"
import style0 from "./QueryContractItem_IV.vue?vue&type=style&index=0&id=6edcb72a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports